import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BackgroundImage from "../../assets/images/notification/decrease.png";

const DecreaseNotification = ({ show, onHide, notification }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    onHide();
  };

  const goChat = () => {
    handleClose();
    navigate(notification.link);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="border-bottom-0" closeButton></Modal.Header>
      <Modal.Body className="text-primary">
        <img className="img img-fluid" src={BackgroundImage} alt="background" />
        <div className="text-captialize text-xxl fw-bold mt-3 mb-3">
          We're here to support you
        </div>
        <div
          className="text-xs"
          dangerouslySetInnerHTML={{ __html: notification.text }}
        />
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0">
        <buton className="btn btn-outline-success" onClick={handleClose}>
          Cancel
        </buton>
        <buton className="btn btn-success text-white" onClick={goChat}>
          Start Chat
        </buton>
      </Modal.Footer>
    </Modal>
  );
};

export default DecreaseNotification;
